import * as React from 'react'
import { Alert, AlertProps, Flex, Typography } from 'antd'

import { CheckAddressResponse } from '../../types'
import { AmlCheckCountdown } from '../AmlCheckCountdown'

type RiskStatusView = {
  type: AlertProps['type']
  title: string
  description?: string
}

const riskStatusViews: Record<string, RiskStatusView> = {
  CLEAN: {
    type: 'success',
    title: '✅ Адрес чистый',
    description:
      'Адрес не найден ни в одном AML/санкционном списке Crypto APIs.',
  },
  SUSPICIOUS: { type: 'warning', title: '⚠️ Подозрительный адрес' },
  DANGEROUS: { type: 'error', title: '⛔ Опасный адрес' },
  BLOCKED: { type: 'error', title: '🚫 Адрес заблокирован' },
}

type AddressResultProps = {
  check: CheckAddressResponse
  refreshing: boolean
  hasError: boolean
  onRefresh: () => void
}

export const AddressResult: React.FC<AddressResultProps> = ({
  check,
  refreshing,
  hasError,
  onRefresh,
}) => {
  const { result } = check

  if (!result) {
    return (
      <Alert
        type="info"
        message={<strong>⏳ Адрес проверяется</strong>}
        description={
          <>
            {!refreshing && !hasError && (
              <AmlCheckCountdown onFinish={onRefresh} />
            )}
            {refreshing && (
              <Typography.Text type="secondary">
                Обновляем статус…
              </Typography.Text>
            )}
          </>
        }
      />
    )
  }

  const view = riskStatusViews[result.riskStatus] ?? {
    type: 'info',
    title: result.riskStatus,
  }

  return (
    <Alert
      type={view.type}
      message={<strong>{view.title}</strong>}
      description={
        <Flex vertical gap={8}>
          {view.description && <span>{view.description}</span>}
          <span>AML-скоринг: {result.amlScore}</span>
          {result.riskFlags.map((flag, index) => (
            <div key={index}>
              <strong>
                {flag.category} / {flag.signal}
              </strong>
              : {flag.description}
            </div>
          ))}
          <Typography.Text type="secondary">
            Проверено: {new Date(result.checkedAt).toLocaleString('ru-RU')}
          </Typography.Text>
        </Flex>
      }
    />
  )
}
